"use strict";
exports.__esModule = true;
exports.FiatCoinType = void 0;
var FiatCoinType;
(function (FiatCoinType) {
    FiatCoinType["USD"] = "USD";
})(FiatCoinType = exports.FiatCoinType || (exports.FiatCoinType = {}));
